export enum ErrorsEnum {
  UNKNOWN_EMAIL = 15003,
}
